






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {Administrador} from '@/model/resource/Administrador'
import {InputAdministradorSchema} from '@/schema/resource/Administrador/InputAdministradorSchema'

@Component
export default class PersistAdministradorView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputAdministradorSchema()
  administrador = new Administrador()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.administrador.getAdministrador(id)
    }

    $.await.done('getAdministrador')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.administrador.persistAdministrador()
    await Helper.successAndPush('system.success.persist', '/administrador/list')
  }
}
